module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "providedby.9635655d.svg";